<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('recipe:page')">
        <a-form layout="inline">
          <a-row :gutter="48">

              <a-col :md="8" :sm="24">
                <a-form-item label="活动名称">
                  <a-input v-model="queryParam.deptName" allow-clear placeholder="请输入活动名称、券名称" />
                </a-form-item>
              </a-col>

              <a-col :md="8" :sm="24">
                <a-form-item label="活动状态">
                  <!-- <a-input v-model="queryParam.status" allow-clear placeholder="请输入状态"/> -->
                  <a-select v-model="queryParam.status" allow-clear placeholder="请选择活动状态" :options="recipeStatus"></a-select>
                </a-form-item>
              </a-col>
            
              <a-col :md="8" :sm="24">
                <a-form-item label="活动时间">
                  <a-date-picker style="width: 100%" placeholder="请选择活动起始时间"  @change="onChangectstamp"/>
                </a-form-item>
              </a-col>
             
              <a-col :md="8" :sm="24">
                <a-form-item label="活动类型">
                  <!-- <a-input v-model="queryParam.businessType" allow-clear placeholder="请输入处方类型"/> -->
                  <a-select v-model="queryParam.category"  allow-clear placeholder="请选择活动类型" :options="category"></a-select>
                </a-form-item>
              </a-col>
            
            <a-col :md="8" :sm="24" >
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)" >查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :alert="options.alert"
        :rowKey="(record) => record.id"
        :rowSelection="options.rowSelection"
      >
        <span slot="searchValue" slot-scope="text, record">
          {{ record.searchValue == null ? '2021年就诊人首次优惠' : '2021年就诊人首次优惠' }}
        </span>
        <span slot="searchBeginTime" slot-scope="text, record">
          {{ record.searchBeginTime == null ? '新用户首诊优惠' : '新用户首诊优惠' }}
        </span>
        <span slot="searchEndTime" slot-scope="text, record">
          {{ record.searchEndTime == null ? '10.00' : '10.00' }}
        </span>
        <span slot="searchStatus" slot-scope="text, record">
          {{ record.searchStatus == null ? '3614/10000' : '3614/10000' }}
        </span>
        <span  slot="patientsex" slot-scope="text, record"> 
            {{ record.patientsex == '1' ? '减免现金' : '减免现金'  }}
        </span>
        <span slot="negotiationFlag" slot-scope="text, record">
           <a> {{ record.negotiationFlag == '0' ? '进行中' : record.negotiationFlag == '1' ? '已结束' : '待开始' }} </a>
        </span>
        <span  slot="category" slot-scope="text, record"> 
            {{record.category == '1'? '西药/中成药' : record.category == '2'? '中药处方' : '' }}
        </span>
        <span  slot="status" slot-scope="text, record">
            {{ record.status == '1' ? '极速问诊' : record.status == '2' ? '图文问诊' : record.status == '3' ? '专家问诊' : record.status == '4' ? '全品类' : record.status == '5' ? '极速问诊' : '专家问诊'  }}
        </span> 

        <span slot="action">
          <a  style="margin-right:5px">详情</a>


          <a-popconfirm placement="topRight" title="确认下架？"
            @confirm="() => queryParam = {}">
            <a>下架</a>
          </a-popconfirm>

          <!-- <a-divider type="vertical" v-if="hasPerm('recipe:edit') & hasPerm('recipe:delete')"/> -->
          <!-- <a-popconfirm v-if="hasPerm('recipe:delete')" placement="topRight" title="确认删除？" @confirm="() => singleDelete(record)">
            <a>删除</a> 
          </a-popconfirm> -->

        </span>
      </s-table>
      
    </a-card>
    <add-form-xi ref="addFormXi" @ok="handleOk" />
    <add-form-zhong ref="addFormZhong" @ok="handleOk" />
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import moment from 'moment'
  import { recipePage, recipeExport, recipePreVer, recipeUpload } from '@/api/modular/interhospital/marketing/marketingManage'
  import addFormXi from './addForm.vue'
  import addFormZhong from './addFormZhong.vue'
  import editForm from './editForm.vue'
  export default {
    components: {
      STable,
      editForm,
      addFormXi,
      addFormZhong,
      XDown
    },
    data () {
      return {
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 审核状态
        recipeStatus : [
          {
            value: '',
            label: '全部',
          },
          {
            value: '1',
            label: '待开始',
          },
          {
            value: '2',
            label: '进行中',
          },
          {
            value: '3',
            label: '已结束',
          },
          
        ],
        // 处方类型
        category : [
          {
            value: '1',
            label: '优惠券',
          },
          {
            value: '2',
            label: '积分商品',
          },
          {
            value: '3',
            label: '券活动',
          },
        ],
        // 表头
        columns: [
          {
            title: '活动名称',
            align: 'center',
            dataIndex: 'searchValue',
            scopedSlots: { customRender: 'searchValue' },
          },
          {
            title: '优惠券名称',
            align: 'center',
            dataIndex: 'searchBeginTime',
            scopedSlots: { customRender: 'searchBeginTime' },
          },
          {
            title: '面额/折扣',
            align: 'center',
            dataIndex: 'searchEndTime',
            scopedSlots: { customRender: 'searchEndTime' },
          },
          {
            title: '已领取/总数',
            align: 'center',
            dataIndex: 'searchStatus',
            scopedSlots: { customRender: 'searchStatus' },
          },
          {
            title: '优惠券类型',
            align: 'center',
            dataIndex: 'patientsex',
            scopedSlots: { customRender: 'patientsex' },
          },
          {
            title: '品类描述',
            align: 'center',
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: '状态',
            align: 'center',
            dataIndex: 'negotiationFlag',
            scopedSlots: { customRender: 'negotiationFlag' },
          },
          {
            title: '活动时间',
            align: 'center',
            dataIndex: 'createTime'
          },
          
        ],
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return recipePage(Object.assign(parameter, this.switchingDate())).then((res) => {
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },
    created () {
      if (this.hasPerm('recipe:edit') || this.hasPerm('recipe:delete')) {
        this.columns.push({
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
      }
    },
    methods: {
      moment,
      /**
       * 查询参数组装
       */
      switchingDate () {
        const queryParamctstamp = this.queryParam.ctstampDate
        if (queryParamctstamp != null) {
            this.queryParam.ctstamp = moment(queryParamctstamp).format('YYYY-MM-DD')
            if (queryParamctstamp.length < 1) {
                delete this.queryParam.ctstamp
            }
        }
        const obj = JSON.parse(JSON.stringify(this.queryParam))
        return obj
      },
      // 搜索框展开切换
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      // 时间框赋值
      onChangectstamp(date, dateString) {
        this.queryParam.createTime = dateString
      },
      /**
       * 批量导出
       */
      batchExport () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        recipeExport(paramIds).then((res) => {
            this.$refs.batchExport.downloadfile(res)
        })
      },

      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      // 调用查询接口
      getTable(){
        console.log(this.$refs.table)
        this.$refs.table.refresh();
        // this.loadData =  recipePage({}).then((res) => {
        //   console.log(res)
        //   return res.data;
        // })
      },

      // 点击查看详情
      clickDetial(record , isShow) {
        if (record.category == 1) {
          this.$refs.addFormXi.add(record, isShow)
        } else {
          this.$refs.addFormZhong.add(record, isShow)
        }
      },

     
      /**
       *调用处方上传
       */
      clickUpload(record) {
        recipePreVer({ recipeId: record.id }).then(res => {
          const params = JSON.parse(res.msg)

          if (res.code == 0) {
            
            const parameter = {
              recipeId: record.id,
              rxTraceCode: params.rxTraceCode,
              hiRxno: params.hiRxno,
              mdtrtId: params.mdtrtId
            }
            recipeUpload(parameter).then(res => {
              if (res.code == 0) {
                this.$message.success('上传成功');
              } else {
                const msg = JSON.parse(res.msg)
                this.$message.success(msg.message);
              }

            })
          } else { 
            this.$message.error(params.message);
          }
          
        })
        

       
      }
    }
  }
</script>
<style lang="less">
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
</style>
